var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { darken } from 'polished';
import React from 'react';
import { color, space, typography } from 'styled-system';
import { css, styled } from "../utils";
var StyledTextLink = styled.a(function (_a) {
    var align = _a.align, _b = _a.theme, colors = _b.colors, font = _b.font;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-align: ", ";\n    color: ", ";\n    font-family: ", ";\n    display: block;\n    font-weight: ", ";\n    margin: 0.5rem 0;\n    line-height: 1.5;\n    text-decoration: underline;\n\n    &:hover {\n      cursor: pointer;\n    }\n\n    &:hover,\n    &:active,\n    &:focus {\n      color: ", ";\n    }\n  "], ["\n    text-align: ", ";\n    color: ", ";\n    font-family: ", ";\n    display: block;\n    font-weight: ", ";\n    margin: 0.5rem 0;\n    line-height: 1.5;\n    text-decoration: underline;\n\n    &:hover {\n      cursor: pointer;\n    }\n\n    &:hover,\n    &:active,\n    &:focus {\n      color: ", ";\n    }\n  "])), align, colors.primary, font.family.proximaNova, font.weight.semiBold, darken(0.05, colors.primary));
}, typography, color, space);
var TextLink = function (props) { return (React.createElement(StyledTextLink, __assign({ "data-component": "TextLink" }, props))); };
TextLink.defaultProps = {
    align: 'left',
};
export default TextLink;
var templateObject_1;
//# sourceMappingURL=TextLink.js.map